<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader" :items="tableRows" :search="search" disable-sort>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:[`item.nomeItem`]="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip @click="openNomeItem(props.item)" v-bind="attrs" v-on="on" :color="props.item.chipColor" dark>
                {{ props.item.nomeItem }}
              </v-chip>
            </template>
            <span>Verificar nome do produto</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.itemIsEdit`]="props">
          <v-checkbox v-model="props.item.itemIsEdit" color="success" :true-value="true" :false-value="false" hide-details></v-checkbox>
        </template>

        <template v-slot:[`item.lote`]="props">
          <v-text-field style="max-width:120px" v-model="props.item.lote" label="Lote" single-line :disabled="!props.item.itemIsEdit" :rules="[rules.required]"></v-text-field>
        </template>

        <template v-slot:[`item.validade`]="props">
          <v-text-field style="max-width:120px" v-model="props.item.validade" label="Validade" single-line v-mask="['##/##/####']" :rules="[rules.date]" :disabled="!props.item.itemIsEdit" @change="verificaValidade(props.item.validade)"></v-text-field>
        </template>

        <template v-slot:[`item.novaQuantidadeRecebida`]="props">
          <v-text-field style="max-width:60px" v-model="props.item.novaQuantidadeRecebida" label="Quantidade Recebida" single-line :disabled="!props.item.itemIsEdit" @keypress="(event) => filter(event)" :rules="[rules.required]"></v-text-field>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="item.indicadorStatus != 8 && isStatus" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableUpdateStatusRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Atualizar Status</span>
          </v-tooltip>

          <v-tooltip v-if="isDel && item.indicadorStatusSolicitarItem != 2 && item.indicadorStatusSolicitarItem != 1" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableDeleteRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <DialogCustom :openDialog="dialogCustom.openDialog" :sizeDialog="dialogCustom.sizeDialog" :titleDialog="dialogCustom.titleDialog" v-on:dialog-close="cancel" v-on:dialog-action="save">
        <v-row>
          <v-col cols="12">
            <div class="text-h5">Produtos Relacionados</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-caption">Produto selecionado:</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pt-0">
            <div class="text-subtitle-1">
              <b>{{ nomeProdutoSelecionado }}</b>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-radio-group row v-model="procuraPorNome">
              <v-radio label="Produtos Relacionados" value="true"></v-radio>
              <v-radio label="Todos os Produtos" value="false"></v-radio>
            </v-radio-group>
          </v-col>

          <v-expand-transition>
            <v-col cols="12" v-if="mostrarItensParaVincular">
              <v-autocomplete v-model="numeroItemSistemaUnidadeSelecionado" :items="listaItensParaVincular" label="Produtos para Vincular" :loading="!listaItensParaVincular.length" :no-data-text="loadingAutocomplete.noDataTextProdutosVincular" autocomplete="off" clearable></v-autocomplete>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12" v-if="mostrarProdutoFamilia">
              <v-autocomplete v-model="indicadorStatusFamiliaSelecionado" :items="listaIndicadorStatusFamilia" label="Selecione a Familia do Produto" autocomplete="off" clearable></v-autocomplete>
            </v-col>
          </v-expand-transition>
        </v-row>
      </DialogCustom>
    </v-card>

    <v-snackbar v-model="snackbar.habilitar" :timeout="3000" :color="snackbar.cor">
      {{ snackbar.texto }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackbar.habilitar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "../plugins/axios";
import DialogCustom from "../components/DialogCustom.vue";

export default {
  components: {
    DialogCustom,
  },

  props: {
    tableTitle: String,
    tableHeader: Array,
    tableRows: Array,
    tableHeadersItensRelacionados: Array,
    tableRowItensRelacionados: Array,
    isStatus: Boolean,
    isDel: Boolean,
    config: Object,
  },

  data: function() {
    return {
      singleSelect: false,
      selected: [],
      numeroItemSistemaUnidadeSelecionado: null,

      search: "",

      rules: {
        required: (value) => !!value || "Requer o campo!",
        date: (value) => value.length >= 10 || "Por favor insira a data completa!",
      },

      filtragem: {
        procuraPorNome: null,
        nomeItem: null,
        numeroEndereco: this.$store.getters.numeroEndereco,
      },

      dialogCustom: {
        openDialog: null,
        sizeDialog: "600",
        titleDialog: null,
      },

      snackbar: {
        habilitar: false,
        cor: null,
        texto: null,
      },

      loadingAutocomplete: {
        noDataTextProdutosVincular: "Carregando lista de produtos...",
      },

      itemVincularSelecionado: null,
      listaItensParaVincular: [],

      indicadorStatusFamiliaSelecionado: null,
      listaIndicadorStatusFamilia: [
        {
          text: "Medicamentos",
          value: "1",
        },
        {
          text: "Materiais",
          value: "2",
        },
        {
          text: "Psicotropicos",
          value: "3",
        },
        {
          text: "Saneantes",
          value: "4",
        },
        {
          text: "Cosmeticos",
          value: "5",
        },
        {
          text: "Nutrição",
          value: "6",
        },
        {
          text: "Antimicrobianos",
          value: "7",
        },
        {
          text: "Amostra Grátis",
          value: "8",
        },
        {
          text: "Maleta de Emergência",
          value: "9",
        },
        {
          text: "Doação",
          value: "10",
        },
        {
          text: "Teste Rápido",
          value: "11",
        },
        { 
          text: "USO INTERNO", 
          value: 12 
        },
      ],

      mostrarItensParaVincular: false,
      mostrarProdutoFamilia: false,

      nomeProdutoSelecionado: null,
      procuraPorNome: null,
      itemSelecionado: null,
      dataVerificada: null,
    };
  },

  watch: {
    procuraPorNome() {
      this.mostrarItensParaVincular = false;

      if (this.procuraPorNome) {
        if (this.procuraPorNome == "true") {
          this.filtragem.procuraPorNome = true;
        } else if (this.procuraPorNome == "false") {
          this.filtragem.procuraPorNome = false;
        }

        this.listarPorFiltroReceberItem(this.filtragem);
      }
    },

    numeroItemSistemaUnidadeSelecionado() {
      this.mostrarProdutoFamilia = true;
    },
  },

  methods: {
    // async listarPorFiltro(filtragem) {
    //   try {
    //     let response = await axios.put("searchItemSistemaUnidade", filtragem, this.config);

    //     if (response.data.length == 0) {
    //       this.loadingAutocomplete.noDataTextProdutosVincular = "Não há produtos relacionados";
    //     }

    //     this.listaItensParaVincular = response.data.map((itemSelecionado) => {
    //       return {
    //         value: itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
    //         text: itemSelecionado.itemSistema.nomeItemSistema,
    //       };
    //     });

    //     this.mostrarItensParaVincular = true;
    //   } catch (error) {
    //     console.log(error);
    //     this.mensagemErroModal.text = error.response.data.message;
    //     this.mensagemErroModal.erro = true;
    //   }
    // },

    async listarPorFiltroReceberItem(filtragem) {
      try {
        let response = await axios.put("searchItemSistemaUnidadeReceberItem", filtragem, this.config);

        if (response.data.length == 0) {
          this.loadingAutocomplete.noDataTextProdutosVincular = "Não há produtos relacionados";
        }

        this.listaItensParaVincular = response.data.map((itemSelecionado) => {
          return {
            value: itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: itemSelecionado.itemSistema.nomeItemSistema,
          };
        });

        this.mostrarItensParaVincular = true;
      } catch (error) {
        console.log(error);
        this.mensagemErroModal.text = error.response.data.message;
        this.mensagemErroModal.erro = true;
      }
    },

    async openNomeItem(item) {
      this.dialogCustom.openDialog = false;
      this.nomeProdutoSelecionado = item.nomeItem;
      this.numeroItemSistemaUnidadeSelecionado = null;
      this.indicadorStatusFamiliaSelecionado = null;
      this.mostrarItensParaVincular = false;
      this.mostrarProdutoFamilia = false;

      this.itemSelecionado = item;
      this.dialogCustom.openDialog = true;

      if (item.numeroItemSistemaUnidade) {
        this.procuraPorNome = "false";
        this.mostrarItensParaVincular = true;
        this.numeroItemSistemaUnidadeSelecionado = item.numeroItemSistemaUnidade;
        this.indicadorStatusFamiliaSelecionado = item.statusFamilia;
      } else {
        this.procuraPorNome = null;
        this.mostrarItensParaVincular = false;
      }

      this.filtragem.nomeItem = item.nomeItem;
    },

    save() {
      try {
        if (this.numeroItemSistemaUnidadeSelecionado) {
          this.snackbar.habilitar = true;
          this.snackbar.cor = "success";
          this.snackbar.texto = "Sucesso! Nome do produto padronizado";

          this.itemSelecionado.chipColor = "green";
          this.itemSelecionado.numeroItemSistemaUnidade = this.numeroItemSistemaUnidadeSelecionado;
          this.itemSelecionado.statusFamilia = this.indicadorStatusFamiliaSelecionado;
          this.itemSelecionado.nomeItemVerificado = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.dialogCustom.openDialog = false;
        this.numeroItemSistemaUnidadeSelecionado = null;
        this.indicadorStatusFamiliaSelecionado = null;
        this.mostrarItensParaVincular = false;
        this.mostrarProdutoFamilia = false;
      }
    },

    cancel() {
      try {
        this.snackbar.habilitar = true;
        this.snackbar.cor = "info";
        this.snackbar.texto = "Cancelado edição";
      } catch (error) {
        console.log(error);
      } finally {
        this.dialogCustom.openDialog = false;
        this.numeroItemSistemaUnidadeSelecionado = null;
        this.indicadorStatusFamiliaSelecionado = null;
        this.mostrarItensParaVincular = false;
        this.mostrarProdutoFamilia = false;
      }
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    verificaValidade(data) {
      this.snackbar.texto = "";
      this.snackbar.cor = "";
      this.snackbar.habilitar = null;
      this.dataVerificada = data.split("/");

      if (data) {
        if (this.dataVerificada[0] == 0 && this.dataVerificada[1] == 0 && this.dataVerificada[2] == 0) {
          this.dataVerificada = data;
        } else if (this.dataVerificada[0] > 31 || this.dataVerificada[0] <= 0) {
          this.snackbar.texto = "Dia inserido na validade do produto é inválido.";
          this.snackbar.cor = "error";
          this.snackbar.habilitar = true;
        } else if (this.dataVerificada[1] <= 0 || this.dataVerificada[1] > 12) {
          this.snackbar.texto = "Mes inserido na validade do produto é inválido.";
          this.snackbar.cor = "error";
          this.snackbar.habilitar = true;
        } else if (this.dataVerificada[2] <= 2018 || this.dataVerificada[2] >= 3000) {
          this.snackbar.texto = "Ano inserido na validade do produto é inválido.";
          this.snackbar.cor = "error";
          this.snackbar.habilitar = true;
        } else if (this.dataVerificada[2] > 2018 && this.dataVerificada[2] <= 2020) {
          this.snackbar.texto = "Aviso, o ano inserido na validade do produto consta como vencido.";
          this.snackbar.cor = "warning";
          this.snackbar.habilitar = true;
        } else {
          this.dataVerificada = data;
        }
      } else {
        this.alertaModal.texto = "";
        this.alertaModal.tipo = "";
      }
    },

    emitDataTableUpdateStatusRowEvent(row) {
      this.$emit("datatable-updatestatusrow", row);
    },

    emitDataTableDeleteRowEvent(row) {
      this.$emit("datatable-deleterow", row);
    },
  },
};
</script>
